document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    var header = document.querySelector(".cdk_header");
    if (header) {
      if (window.scrollY > 50) {
        header.classList.add("cdk_scrolled");
      } else {
        header.classList.remove("cdk_scrolled");
      }
    }
  });

  var blogFilterSpans = document.querySelectorAll(".blog_fliter span");
  if (blogFilterSpans.length > 0) {
    blogFilterSpans.forEach(function (span) {
      span.addEventListener("click", function () {
        var blogFilterWrapper = document.querySelector(".blog_fliter_wrapper");
        if (blogFilterWrapper) {
          blogFilterWrapper.classList.add("show_filter");
        }
      });
    });
  }

  var blogFilterTopSvg = document.querySelector(".blog_fliter_top svg");
  if (blogFilterTopSvg) {
    blogFilterTopSvg.addEventListener("click", function () {
      var blogFilterWrapper = document.querySelector(".blog_fliter_wrapper");
      if (blogFilterWrapper) {
        blogFilterWrapper.classList.remove("show_filter");
      }
    });
  }

  const tagList = document.querySelectorAll("#BlogTagFilter li");
  if (tagList.length > 0) {
    const applyButton = document.querySelector(".apply_btn");
    let selectedTag = null;

    tagList.forEach(function (li) {
      li.addEventListener("click", function () {
        // Remove active tag class from all items
        tagList.forEach(function (li) {
          li.classList.remove("cdk_active_tag");
        });
        // Add active class to the clicked tag
        li.classList.add("cdk_active_tag");
        selectedTag = li.querySelector("a");
      });
    });

    if (applyButton) {
      applyButton.addEventListener("click", function (event) {
        if (selectedTag) {
          event.preventDefault(); // Prevent default form submission or link behavior
          selectedTag.click(); // Simulate a click on the selected tag
        }
      });
    }
  }

  /* Quiz page */

  // $(document).on("click", ".question-banner .banner-buttons .button", function () {
  //   let videoLink = $(this).attr('video_link');
  //   let posterLink = $(this).attr('poster_link');
  //   let resultProduct = $(this).attr('result_product_tab');
  //   let videoElement = $(this).parents('.question-banner-main').find('.question-banner.hero .bg_video video');
  //   let audioElement = $(this).find('.audio_link audio')[0];
  //   $(this).parents('.banner-buttons').find('.button').removeClass("active");
  //   $(this).addClass("active");
  //   if (videoLink && videoElement && videoLink.trim() !== '') {
  //     videoElement.find('source').attr("src", videoLink);
  //     videoElement.find('img').attr("src", posterLink);
  //     videoElement.attr("poster", posterLink);
  //     videoElement[0].load();
  //     videoElement[0].onloadeddata = function() {
  //         this.play();
  //     };
  //   }
  //   $(this).parents('.question-banner-main').find('.audio_link audio').each(function() {
  //       if (!this.paused) {
  //           this.pause();
  //           this.currentTime = 0;
  //       }
  //   });
  //   if (audioElement) {
  //       audioElement.play();
  //   }
  //   if (resultProduct && resultProduct.trim() !== '') {
  //     $('.quiz-result-main .multi-products').hide();
  //     $('.quiz-result-main .multi-products[result_product_tab="' + resultProduct + '"]').css('display', 'flex');
  //   }
  //   $(this).parents('.question-banner-main').find('.banner-footer .next_button.disabled').removeClass("disabled");
  // });
  
  document.addEventListener("click", function (event) {
    
      if (event.target.matches(".question-banner .banner-buttons .button")) {
          let button = event.target;
  
          let videoLink = button.getAttribute('video_link');
          let posterLink = button.getAttribute('poster_link');
          let imageLink = button.getAttribute('image_link');
          let resultProduct = button.getAttribute('result_product_tab');
          let videoElement = button.closest('.question-banner-main').querySelector('.question-banner.hero .bg_video video');
          let imageElement = button.closest('.question-banner-main').querySelector('.question-banner.hero picture .image');
          let audioElement = button.querySelector('.audio_link audio');
  
          let siblingButtons = button.closest('.banner-buttons').querySelectorAll('.button');
          siblingButtons.forEach(btn => btn.classList.remove("active"));
          button.classList.add("active");
  
          if (videoLink && videoElement && videoLink.trim() !== '') {
              let sourceElement = videoElement.querySelector('source');
              if (sourceElement) {
                  sourceElement.setAttribute("src", videoLink);
              }
              let imgElement = videoElement.querySelector('img');
              if (imgElement) {
                  imgElement.setAttribute("src", posterLink);
              }
              videoElement.setAttribute("poster", posterLink);
              videoElement.load();
              videoElement.onloadeddata = function () {
                  videoElement.play();
              };
          }

          if (imageLink && imageElement !== '') {
              if (imageElement) {
                  imageElement.setAttribute("src", imageLink);
              }
          }

          let allAudioElements = button.closest('.question-banner-main').querySelectorAll('.audio_link audio');
          allAudioElements.forEach(audio => {
              if (!audio.paused) {
                  audio.pause();
                  audio.currentTime = 0;
              }
          });
  
          if (audioElement) {
              audioElement.play();
          }
  
          if (resultProduct && resultProduct.trim() !== '') {
              let multiProducts = document.querySelectorAll('.quiz-result-main .multi-products');
              multiProducts.forEach(product => {
                  product.style.display = "none";
              });
              let resultProductElement = document.querySelector('.quiz-result-main .multi-products[result_product_tab="' + resultProduct + '"]');
              if (resultProductElement) {
                  resultProductElement.style.display = "flex";
              }
          }
  
          let nextButton = button.closest('.question-banner-main').querySelector('.question-banner .next_button.disabled');
          if (nextButton) {
              nextButton.classList.remove("disabled");
          }
      }
  });

  document.addEventListener("click", function (event) {
    if (event.target.matches("section .next_button")) {
      const currentSection = event.target.closest("section");
      const currentStep = currentSection
        ? currentSection.getAttribute("step_index")
        : null;
      const nextStep = event.target.getAttribute("step_open");

      if (currentStep) {
        // console.log("This step: ", currentStep);
        const currentSectionElement = document.querySelector(
          `section[step_index="${currentStep}"]`
        );
        if (currentSectionElement) {
          currentSectionElement.style.display = "none";
        }
      } else {
        console.error("step_index attribute is missing or not set.");
      }

      if (nextStep) {
        // console.log("Next step: ", nextStep);
        const nextSectionElement = document.querySelector(
          `section[step_index="${nextStep}"]`
        );
        if (nextSectionElement) {
          nextSectionElement.style.display = "block";
        }
      } else {
        console.error("step_open attribute is missing or not set.");
      }
      const questionBannerMain = event.target.closest('.question-banner-main');
      if (questionBannerMain) { // Add this check
        let allAudioElements = questionBannerMain.querySelectorAll('.audio_link audio');
        if (allAudioElements) {
          allAudioElements.forEach(audio => {
            if (!audio.paused) {
              audio.pause();
              audio.currentTime = 0;
            }
          });
        }
      }
    }
  });

  document.addEventListener("click", function (event) {
    if (event.target.matches("section .prev_button")) {
      const currentSection = event.target.closest("section");
      const currentStep = currentSection
        ? currentSection.getAttribute("step_index")
        : null;
      const prevStep = event.target.getAttribute("step_open");

      if (currentStep) {
        // console.log("This step: ", currentStep);
        const currentSectionElement = document.querySelector(
          `section[step_index="${currentStep}"]`
        );
        if (currentSectionElement) {
          currentSectionElement.style.display = "none";
        }
      } else {
        console.error("step_index attribute is missing or not set.");
      }

      if (prevStep) {
        // console.log("Previous step: ", prevStep);
        const prevSectionElement = document.querySelector(
          `section[step_index="${prevStep}"]`
        );
        if (prevSectionElement) {
          prevSectionElement.style.display = "block";
        }
      } else {
        console.error("step_open attribute is missing or not set.");
      }
      const questionBannerMain = event.target.closest('.question-banner-main');
      if (questionBannerMain) { // Add this check
        let allAudioElements = questionBannerMain.querySelectorAll('.audio_link audio');
        if (allAudioElements) {
          allAudioElements.forEach(audio => {
            if (!audio.paused) {
              audio.pause();
              audio.currentTime = 0;
            }
          });
        }
      }
    }
  });
  /* klaviyo form submit trigger click */
  window.addEventListener("klaviyoForms", function(e) {
      if (e.detail && e.detail.type === 'submit') {
          // Ensure the form exists before proceeding
          const specificForm = document.querySelector('.newsletter-banner .content .custom_code form.klaviyo-form');
          if (!specificForm) return; // Exit if form is not found
  
          // Ensure the target button exists before proceeding
          const targetButton = specificForm.closest('.newsletter-banner-main')?.querySelector('.newsletter-banner .next_button');
          if (!targetButton) return; // Exit if button is not found
  
          // Wait for a second before clicking the button (ensure this is needed)
          setTimeout(function() {
              targetButton.click();
          }, 500);
      }
  });

  /* end Quiz page */

  /* Product page */
  document.addEventListener("click", function (e) {
    const thumbnail = e.target.closest(
      ".thumbnail-list.thumbnail_custom_desktop .thumbnail-slider__slide"
    );
    if (!thumbnail) return; // Exit if not clicking on the relevant element

    e.preventDefault();

    const mediaTab = thumbnail.getAttribute("media-tab");
    const mediaGallery = thumbnail.closest("media-gallery");

    // Check if required elements exist
    if (!mediaGallery || !mediaTab) {
      console.warn("Missing required elements");
      return;
    }

    // Update aria-current for thumbnails
    const thumbnails = mediaGallery.querySelectorAll(
      ".thumbnail-slider .thumbnail-slider__slide .thumbnail"
    );
    thumbnails.forEach((tn) => tn.removeAttribute("aria-current"));

    const activeThumbnail = mediaGallery.querySelector(
      `.thumbnail-slider .thumbnail-slider__slide[data-media-position='${mediaTab}'] .thumbnail`
    );
    if (activeThumbnail) {
      activeThumbnail.setAttribute("aria-current", "true");
    }

    // Update active states for main images
    const mainSlides = mediaGallery.querySelectorAll(
      "slider-component.main-images .slider__slide"
    );
    mainSlides.forEach((slide) => slide.classList.remove("is-active"));
    const activeSlide = mediaGallery.querySelector(
      `slider-component.main-images .slider__slide[media-position='${mediaTab}']`
    );
    // if (activeSlide) {
    //   activeSlide.classList.add("is-active");

    //   // Scroll main image into view with offset
    //   const offset = 90; // Adjust based on your layout (e.g., fixed header height)
    //   const slideTop =
    //     activeSlide.getBoundingClientRect().top + window.pageYOffset;
    //   const scrollPosition = slideTop - offset;

    //   // Animate scrolling to make the active slide appear at the top
    //   window.scrollTo({
    //     top: scrollPosition,
    //     behavior: "smooth",
    //   });
    // }
    // New code
    const mainImagesWrapper = mediaGallery.querySelector(".main-images-wrapper");
    if (activeSlide) {
      activeSlide.classList.add("is-active");
      // Scroll main image into view within .main-images-wrapper
      const offset = 0; // No external offset needed when scrolling within wrapper
      const wrapperRect = mainImagesWrapper.getBoundingClientRect();
      const slideRect = activeSlide.getBoundingClientRect();
      const scrollTop = activeSlide.offsetTop - wrapperRect.height / 2 + slideRect.height / 2;
      
      mainImagesWrapper.scrollTo({
        top: scrollTop,
        behavior: "smooth"
      });
    }
  });

  // document.addEventListener("scroll", function () {
  //   // Iterate through each slide in the main gallery
  //   const slides = document.querySelectorAll(
  //     "slider-component.main-images .slider__slide"
  //   );

  //   slides.forEach((slide) => {
  //     const mediaPosition = slide.getAttribute("media-position");
  //     const slideRect = slide.getBoundingClientRect();
  //     const slideTop = slideRect.top + window.pageYOffset;
  //     const slideHeight = slide.offsetHeight;
  //     const windowTop = window.pageYOffset;

  //     // Check if the slide is within 100px of the top of the viewport
  //     if (
  //       slideTop <= windowTop + 100 &&
  //       slideTop + slideHeight > windowTop + 100
  //     ) {
  //       const thumbnail = document.querySelector(
  //         `.thumbnail-list.thumbnail_custom_desktop .thumbnail-slider__slide[media-tab='${mediaPosition}']`
  //       );
  //       if (thumbnail) {
  //         thumbnail.classList.add("active");
  //       }
  //     } else {
  //       const thumbnail = document.querySelector(
  //         `.thumbnail-list.thumbnail_custom_desktop .thumbnail-slider__slide[media-tab='${mediaPosition}']`
  //       );
  //       if (thumbnail) {
  //         thumbnail.classList.remove("active");
  //       }
  //     }
  //   });
  // });
  // New scroll code for slide
  document.querySelectorAll(".main-images-wrapper").forEach((mainImagesWrapper) => {
    mainImagesWrapper.addEventListener("scroll", function () {
        const slides = this.querySelectorAll(
            "slider-component.main-images .slider__slide"
        );
        const wrapperRect = this.getBoundingClientRect();
        const wrapperMiddle = wrapperRect.height / 2;

        // Remove active class from all thumbnails first
        const allThumbnails = document.querySelectorAll(
            ".thumbnail-list.thumbnail_custom_desktop .thumbnail-slider__slide"
        );
        allThumbnails.forEach(thumbnail => thumbnail.classList.remove("active"));

        // Find the slide most centered in the wrapper
        let mostCenteredSlide = null;
        let smallestDistance = Infinity;

        slides.forEach((slide) => {
            const slideRect = slide.getBoundingClientRect();
            const slideTop = slide.offsetTop;
            const slideHeight = slide.offsetHeight;
            const slideMiddle = slideTop + (slideHeight / 2);
            const distance = Math.abs(slideMiddle - this.scrollTop - wrapperMiddle);

            if (distance < smallestDistance) {
                smallestDistance = distance;
                mostCenteredSlide = slide;
            }
        });

        // Add active class to the thumbnail of the most centered slide
        if (mostCenteredSlide) {
            const mediaPosition = mostCenteredSlide.getAttribute("media-position");
            const thumbnail = document.querySelector(
                `.thumbnail-list.thumbnail_custom_desktop .thumbnail-slider__slide[media-tab='${mediaPosition}']`
            );
            
            if (thumbnail) {
                thumbnail.classList.add("active");
            }
        }
    });
  });
  /* end Product page */
});

/* Tester Popup */

// $(document).on("click", ".tester-popup-button", function () {
//   $('.tester-popup-button').removeClass("active");
//   $(this).addClass("active");
// });

// $(document).on("click", ".tester-popup-select-button", function () {
//   let sampleSelect = $(this).parents('.tester-popup-bottom').find('.tester-popup-button.active').attr('sample_select');
//   console.log("sampleSelect::"+ sampleSelect);
//   $(this).parents('.tester-popup-content-wrapper').find('.tester-products .sample_product_select[sample_select="' +sampleSelect+ '"] form .cartButton').trigger("click");
//   setTimeout(function () {
//     $('.tester-popup').removeClass('active');
//     $('html, body').removeClass('overflow__hidden');
//   },1200);
// });

// $(document).on("click", ".product__ATC:not(.sample_product_select) .cartButton", function () {
//   // $('.sample-product .product__ATC.sample_product_select form .cartButton').trigger('click');
//   setTimeout(function () {
//   $('.sample-product .product__ATC.sample_product_select form .cartButton').trigger('click');
//     $('.tester-popup').addClass('active');
//     $('html, body').addClass('overflow__hidden');
//   },1500);
// });

// document.addEventListener('DOMContentLoaded', function() {

//   document.querySelectorAll('.tester-popup [data-close-button]').forEach((item) => {
//     const testerPopup = item.closest('.tester-popup');
//     item.addEventListener('click', () => {
//       testerPopup.classList.remove('active');
//       document.documentElement.classList.remove('overflow__hidden');
//       document.body.classList.remove('overflow__hidden');
//       document.querySelectorAll('.tester-popup-button').forEach(button => {
//         button.classList.remove('active');
//       });
//     });
//   });

//   // Delegate event listener for tester popup buttons
//   document.addEventListener('click', function(event) {
//     // Handle tester popup button selection
//     if (event.target.closest('.tester-popup-button')) {
//       // Remove active class from all tester popup buttons
//       document.querySelectorAll('.tester-popup-button').forEach(button => {
//         button.classList.remove('active');
//       });

//       // Add active class to clicked button
//       event.target.closest('.tester-popup-button').classList.add('active');
//     }

//     // Handle tester popup select button
//     if (event.target.closest('.tester-popup-select-button')) {
//       const selectButton = event.target.closest('.tester-popup-select-button');
//       const popupContent = selectButton.closest('.tester-popup-content-wrapper');

//       // Find the active sample select
//       const activeSampleSelect = popupContent
//         .querySelector('.tester-popup-bottom .tester-popup-button.active')
//         ?.getAttribute('sample_select');

//       // console.log("sampleSelect::" + activeSampleSelect);

//       // Find and trigger cart button for selected sample
//       const targetCartButton = popupContent
//         .querySelector(`.sample_product_select[sample_select="${activeSampleSelect}"] form .cartButton`);

//       if (targetCartButton) {
//         targetCartButton.click();
//       }

//       // Close popup after a delay
//       setTimeout(function() {
//         document.querySelector('.tester-popup').classList.remove('active');
//         document.querySelectorAll('.tester-popup-button').forEach(button => {
//           button.classList.remove('active');
//         });
//         document.documentElement.classList.remove('overflow__hidden');
//         document.body.classList.remove('overflow__hidden');
//       }, 1200);
//     }

//     // Handle product Add to Cart button
//     if (event.target.closest('.product__ATC:not(.sample_product_select) .cartButton')) {
//       setTimeout(function() {
//         document.querySelector('.tester-popup').classList.add('active');
//         document.documentElement.classList.add('overflow__hidden');
//         document.body.classList.add('overflow__hidden');
//       }, 1500);
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const testerPopups = document.querySelectorAll(
    ".tester-popup [data-close-button]"
  );

  if (testerPopups.length > 0) {
    testerPopups.forEach((item) => {
      const testerPopup = item.closest(".tester-popup");
      item.addEventListener("click", () => {
        if (testerPopup) {
          testerPopup.classList.remove("active");
        }

        document.documentElement?.classList.remove("overflow__hidden");
        document.body?.classList.remove("overflow__hidden");

        const testerPopupButtons = document.querySelectorAll(
          ".tester-popup-button"
        );
        testerPopupButtons.forEach((button) =>
          button.classList.remove("active")
        );
      });
    });
  }

  // Flag and timeout for sample ATC button click
  let hasClickedSampleATC = false;

  document.addEventListener("click", function (event) {
    const popupButton = event.target.closest(".tester-popup-button");
    if (popupButton) {
      const testerPopupButtons = document.querySelectorAll(
        ".tester-popup-button"
      );
      testerPopupButtons.forEach((button) =>
        button.classList.remove("active")
      );
      popupButton.classList.add("active");
    }

    const selectButton = event.target.closest(".tester-popup-select-button");
    if (selectButton) {
      const popupContent = selectButton.closest(".tester-popup-content-wrapper");

      if (popupContent) {
        const errorDiv = popupContent.querySelector(".error");
        const activeSampleSelect = popupContent
          .querySelector(".tester-popup-bottom .tester-popup-button.active")
          ?.getAttribute("sample_select");

        if (!activeSampleSelect) {
          errorDiv && (errorDiv.style.display = "block");
          return;
        } else {
          errorDiv && (errorDiv.style.display = "none");
        }

        const targetCartButton = popupContent.querySelector(
          `.sample_product_select[sample_select="${activeSampleSelect}"] form .cartButton`
        );

        targetCartButton && targetCartButton.click();

        setTimeout(function () {
          const testerPopup = document.querySelector(".tester-popup");
          if (testerPopup) {
            testerPopup.classList.remove("active");
          }

          const popupButtons = document.querySelectorAll(
            ".tester-popup-button"
          );
          popupButtons.forEach((button) =>
            button.classList.remove("active")
          );

          document.documentElement?.classList.remove("overflow__hidden");
          document.body?.classList.remove("overflow__hidden");
        }, 1500);
      }
    }

    const productATCButton = event.target.closest(
      ".product__ATC:not(.sample_product_select) .cartButton"
    );
    
    if (productATCButton) {
      const productParent = productATCButton.closest(".product__ATC");
    
      if (productParent && !hasClickedSampleATC) {
        hasClickedSampleATC = true; // Prevent further clicks
        
        const testerPopup = document.querySelector(".tester-popup");
        const sampleProductATCButton = productParent.querySelector(".sample_product_select .cartButton");
    
        if (sampleProductATCButton) {
          sampleProductATCButton.click();
        }
    
        setTimeout(() => {
          if (testerPopup) {
            testerPopup.classList.add("active");
          }
    
          document.documentElement?.classList.add("overflow__hidden");
          document.body?.classList.add("overflow__hidden");
        }, 2000);
    
        // Reset the flag after some time to allow future clicks
        setTimeout(() => {
          hasClickedSampleATC = false;
        }, 3000);
      }
    } 
    // else {
    //   console.error("productATCButton not found");
    // }


    const clearButton = document.getElementById("clearButton");
    clearButton &&
      clearButton.addEventListener("click", function () {
        const mobileSearchInput = document.getElementById("inputField");
        mobileSearchInput && (mobileSearchInput.value = "");
      });

    const cdkClearButton = document.getElementById("CdkclearButton");
    cdkClearButton &&
      cdkClearButton.addEventListener("click", function () {
        const centralSearchInput = document.getElementById(
          "centralSearchInput"
        );
        const topSearchInput = document.getElementById("topSearchInput");
        centralSearchInput && (centralSearchInput.value = "");
        topSearchInput && (topSearchInput.value = "");
      });
  });
});



/* End Tester Popup */
